import milestoneService from 'resources/milestone/milestone.service';
import { deleteMilestone } from 'resources/milestone/workflow/deleteMilestone';

const updateMilestonesByDiff = async (milestonesDiff) => {
  const { added: milestonesToAdd, updated: milestonesToUpdate, deleted: milestonesToDelete } = milestonesDiff;

  const addPromises = Promise.all(
    Object.entries(milestonesToAdd).map(([milestoneId, milestoneData]) => (
      milestoneService.createMilestone({
        id: milestoneId,
        ...milestoneData,
        companyId: milestoneData.company_id,
        isAfterAction: milestoneData.is_after_action,
        dueInDays: milestoneData.due_in_days,
        dueRelativeDate: milestoneData.due_relative_date,
        dealId: milestoneData?.deal_id || null,
      })
    )) || [],
  );

  const updatePromises = Promise.all(
    Object.entries(milestonesToUpdate).map(([milestoneId, milestoneData]) => (
      milestoneService.updateOne({ id: milestoneId }, milestoneData)
    )) || [],
  );

  const deletePromises = Promise.all(
    Object.keys(milestonesToDelete).map((milestoneId) => deleteMilestone(milestoneId)) || [],
  );

  const [created, updated, deleted] = await Promise.all([addPromises, updatePromises, deletePromises]);

  return { created, updated, deleted };
};

export { updateMilestonesByDiff };
